// extracted by mini-css-extract-plugin
export var chapter = "chapters-module--chapter--88845";
export var chapterWrap = "chapters-module--chapterWrap--961ef";
export var contact = "chapters-module--contact--b07b4";
export var icon = "chapters-module--icon--5b802";
export var title = "chapters-module--title--c3ef0";